// extracted by mini-css-extract-plugin
export default {"root":"Commission__root--Dp5e8","list":"Commission__list--UCkGu","price-large":"Commission__price-large--t1kop","priceLarge":"Commission__price-large--t1kop"};